export const ENDPOINTS = {
  CREATE_TOKEN: "/careplix/create-token",
  ADD_SCAN: "/careplix/add-scan",
};
